import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Voltage } from '../../../enums/voltage';
import {
  AcLineHistoryDataOut,
  AcLineSegmentDto,
  AcLineSegmentType,
  AcLineSegmentFilter,
  AcLineSearchType,
  AcLineType,
} from '../../../models/ac-line-segment.model';
import { ToastrService } from 'ngx-toastr';
import { GeographicalRegion } from '../../../models/geographical-region.model';
import { SubGeographicalRegion } from '../../../models/sub-geographical-regions.model';
import { SubstationTemplateForSelectDataOut } from '../../../models/substation-template.model';
import {
  SearchSubstationDto,
  SelectSubstationDto,
} from '../../../models/substation-template-instance.model';
import { SelectPowerTransformerDto } from '../../../models/power-transformer.model';
import { AcLineSegmentService } from '../../../services/ac-line-segment.service';
import { GeographicalRegionService } from '../../../services/geographical-region.service';
import { SubGeographicalRegionService } from '../../../services/sub-geographical-region.service';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { NecAddEditModalAcLineSegmentComponent } from '../nec-modals/add-edit-modals/nec-add-edit-modal-ac-line-segment/nec-add-edit-modal-ac-line-segment.component';
import { UploadFileType } from '../../../models/uploadFileInfo.model';
import { NecAddEditModalConnectorSwitchComponent } from '../nec-modals/add-edit-modals/nec-add-edit-modal-connector-switch/nec-add-edit-modal-connector-switch.component';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'lib-nec-ac-line-segment',
  templateUrl: './nec-ac-line-segment.component.html',
  styleUrls: [
    './nec-ac-line-segment.component.scss',
    '../network-entity-classes.component.scss',
  ],
  standalone: false,
})
export class NecAcLineSegmentComponent implements OnInit {
  isEdit: boolean = false;
  modalOpened: boolean = false;
  incomerModalOpened: boolean = false;
  schematicModalOpened: boolean = false;
  selectedAcLineForSchematic: number | null = null;
  Voltage = Voltage;
  AcLineSegmentType = AcLineSegmentType;
  AcLineSearchType = AcLineSearchType;
  initialAcLineSegment: AcLineType.Incoming | null =
    AcLineType.Incoming;
  geographicalRegionValue: GeographicalRegion | null = null;
  powerTransformerInitialValue: SelectPowerTransformerDto | null = null;
  actionMenuOpenForId: number | null = null;
  acLineSegments: AcLineSegmentDto[] = [];
  filter = new AcLineSegmentFilter();

  UploadFileType: UploadFileType = UploadFileType.ACLine;
  uploadModalOpened: boolean = false; 

  updatedRegionId: number | null = 0;
  selectedAcLineSegmentId: { value: number | null } | null = null;
  boundaryId?: number;
  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];
  count: number = 0;

  modalKey: boolean = true;

  filterOpened: boolean = false;
  searchDropdownOpened: boolean = false;

  selectedTab: AcLineSegmentType = AcLineSegmentType.Main;
  selectedSubstationTemplate: number = 0;

  tabs: { id: AcLineSegmentType; name: string; count: number }[] = [
    { id: AcLineSegmentType.Main, name: 'Main AC Line', count: 0 },
    { id: AcLineSegmentType.Incomer, name: 'Incomer AC Line', count: 0 },
    { id: AcLineSegmentType.Primary, name: 'Primary AC Line', count: 0 },
    { id: AcLineSegmentType.Boundary, name: 'Boundary AC Line', count: 0 },
    { id: AcLineSegmentType.Secondary, name: 'Secondary AC Line', count: 0 },
  ];

  geoRegions: GeographicalRegion[] = [];
  allSubGeoRegions: SubGeographicalRegion[] = [];
  substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];
  substationOptions: SelectSubstationDto[] = [];
  powerTransformerOptions: SelectPowerTransformerDto[] = [];
  dataIn: SearchSubstationDto = new SearchSubstationDto();
  displayBaseVoltage: boolean = false;
  baseVoltage: string = '';
  hasBands: boolean = false;
  acLineHistoryItems: AcLineHistoryDataOut[] = [];
  @Output() editModal = new EventEmitter<number>();
  @ViewChild(NecAddEditModalAcLineSegmentComponent)
  NecAddEditModalAcLineSegmentComponent!: NecAddEditModalAcLineSegmentComponent;

  @ViewChild(NecAddEditModalConnectorSwitchComponent)
  NecAddEditModalIncomerComponent!: NecAddEditModalConnectorSwitchComponent;

  constructor(
    private toastr: ToastrService,
    private acLineSegmentService: AcLineSegmentService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private substationTemplateService: SubstationTemplateService,
    public permissionsService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.filter.searchType = AcLineSearchType.Name;
    this.getStats();
    this.getAllAcLineSegments();
    this.loadGeographicalRegions();
    this.loadAllSubGeographicalRegions();
    this.loadSubstationTemplates();
    this.checkBands();
    this.editModal.emit(this.selectedTab != AcLineSegmentType.Incomer ? 1 : 3);
  }

  get acLineModule(): string {
    return this.tabs.find((t) => t.id === this.selectedTab)?.name ?? '';
  }

  switchTab(tab: AcLineSegmentType) {
    this.selectedTab = tab;
    this.filter.acLineType = tab;
    this.getAllAcLineSegments();
    this.checkBands();
    this.editModal.emit(tab != AcLineSegmentType.Incomer ? 1 : 3);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.reloadTable();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.reloadTable();
  }

  save() {}

  openAddModal() {
    this.modalOpened = true;
    this.selectedAcLineSegmentId = null;
    this.NecAddEditModalAcLineSegmentComponent.resetForm();
  }

  openAddIncomerModal() {
    this.incomerModalOpened = true;
    this.selectedAcLineSegmentId = null;
    this.NecAddEditModalIncomerComponent.resetForm();
  }

  reloadTable() {
    this.selectedAcLineSegmentId = null;
    this.getAllAcLineSegments();
  }

  getAllAcLineSegments() {
    var dataIn = {
      pageInfo: {
        pageSize: this.pageSize,
        page: this.currentPage,
      },
      filterParams: this.filter,
    };
    this.acLineSegmentService.getAll(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData.status == 'OK') {
          this.count = responseData.data.count ?? this.count;
          this.acLineSegments = responseData.data.data;
        } else {
          this.acLineSegments = [];
          this.toastr.error(
            responseData?.message ||
              'Failed to fetch AC Line Segment list data',
          );
        }
      },
    });
  }

  getStats() {
    this.tabs.forEach((x) => {
      this.acLineSegmentService.getStats(x.id).subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData.status == 'OK') {
            x.count = responseData.data;
          } else {
            this.toastr.error(
              responseData?.message ||
                'Failed to fetch Count for ' + x.name + 's',
            );
          }
        },
      });
    });
  }

  selectAcLineSegment(acLineSegmentId: number | null) {
    this.actionMenuOpenForId = null;
    this.selectedAcLineSegmentId = { value: acLineSegmentId };
    if (this.selectedTab == AcLineSegmentType.Boundary)
      this.boundaryId = this.acLineSegments.find(x => x.id == acLineSegmentId)!.boundaryId;
    this.modalOpened = true;
  }

  selectIncomerAcLineSegment(acLineSegmentId: number | null) {
    this.actionMenuOpenForId = null;
    this.selectedAcLineSegmentId = { value: acLineSegmentId };
    this.incomerModalOpened = true;
  }

  toggleMenu(acLineSegment: any, event: MouseEvent) {
    event.stopPropagation();
    // this.newInstance = new PowerTransformerCrud({ ...pt });
    this.actionMenuOpenForId =
      this.actionMenuOpenForId === acLineSegment.id ? null : acLineSegment.id;
  }

  selectSearchType(searchType: AcLineSearchType) {
    this.filter.searchType = searchType;
    this.searchDropdownOpened = false;
  }

  onFilterApplied() {
    this.currentPage = 1;
    this.getAllAcLineSegments();
    this.filterOpened = false;
  }

  getSearchTypeLabel(): string {
    switch (this.filter.searchType) {
      case AcLineSearchType.Name:
        return 'Asset Name';
      case AcLineSearchType.Number:
        return 'Asset Number';
      case AcLineSearchType.SubstationName:
        return 'Substation Name';
      default:
        return 'Asset Name';
    }
  }

  loadGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.geoRegions = responseData.data.map(
            (geoRegion: GeographicalRegion) => ({
              ...geoRegion,
              name: geoRegion.name.toUpperCase(),
            }),
          );
        } else {
          this.toastr.error(
            responseData?.message || 'Failed to fetch geographical regions',
          );
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch geographical regions');
      },
    });
  }

  loadAllSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.allSubGeoRegions = responseData.data.map(
            (subGeoRegion: SubGeographicalRegion) => ({
              ...subGeoRegion,
              name: subGeoRegion.name.toUpperCase(),
            }),
          );
        } else {
          this.toastr.error(
            responseData?.message || 'Failed to fetch sub-geographical regions',
          );
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch sub-geographical regions');
      },
    });
  }

  loadSubstationTemplates() {
    this.substationTemplateService.getAllForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.substationTemplateOptions = responseData.data;
        } else {
          this.substationTemplateOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch substation templates');
      },
    });
  }

  openUploadModal(feederBandUpdate: boolean = false) {
    this.UploadFileType = feederBandUpdate
      ? UploadFileType.UpdateFeederBands
      : UploadFileType.ACLine;
    this.uploadModalOpened = true;
  }

  openUpdateModal() {
    this.UploadFileType = UploadFileType.BulkAcLineUpdate;
    this.uploadModalOpened = true;
  }

  download() {
    if(this.filter.acLineType == AcLineSegmentType.Incomer ||
       this.filter.acLineType == AcLineSegmentType.Boundary
    ) {
      this.toastr.warning('Not implemented yet!');
      return;
    }
    this.filter.module = this.acLineModule;
    this.acLineSegmentService.downloadAcLines(this.filter).subscribe({
      next: (response: any) => {
        if (response?.status === 'OK' || response?.status === 200) {
          window.location.href = response.data;
        } else {
          this.toastr.error(response?.message || 'Download failed.');
        }
      },
      error: (_: any) => {
        this.toastr.error('An error occurred during download.');
      },
    });
  }

  openSchematicDiagram(acLineSegmentId: number | null){
    this.selectedAcLineForSchematic = acLineSegmentId;
    this.schematicModalOpened = true;
  }

  closeSchematicDiagram(){
    this.schematicModalOpened = false;
  }

  @HostListener('document:click')
  closeActionMenu() {
    if (this.actionMenuOpenForId !== null) {
      this.actionMenuOpenForId = null;
    }
  }

  viewHistory(acLineId: number) {
    this.acLineSegmentService.getHistory(acLineId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.acLineHistoryItems = responseData.data ?? [];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch history');
        }
      },
      error: (_: any) => {
        this.toastr.error('Failed to fetch history');
      },
    });
  }

  checkBands(){
    this.hasBands = this.permissionsService.hasDashboardConfigFeederBands && this.selectedTab != AcLineSegmentType.Boundary && this.selectedTab != AcLineSegmentType.Incomer;
  }
}
